/**
 * bd-ga4-g9-browse.js
 *
 * Storefront browse for GA4 G-9HLZQW6SRQ only.
 * Loads gtag unless the visitor declined (bd_cookie_consent_v1=essential or a
 * bd:cookie-consent event with granted=false); Consent Mode defaults set in
 * layout/theme.liquid carry the same choice to Google. Hard-gating on the
 * Accept click caused the 2026-08 measurement outage — do not restore it
 * (see ops/google-tag-outage-2026-08/).
 * Sends page_view via config send_page_view: true.
 * gtag('event') copies params and sets send_to G-9HLZQW6SRQ so events
 * do not fan out to G-39 / AW. Queued helper sends get the same pin.
 *
 * Contract: window.bdGa4Browse(name, params) is the first-party path for
 *   view_item, view_item_list, search, add_to_cart, begin_checkout
 * (bd-view-tracking.js calls it after building each payload), the taxonomy
 * events bd_product_view, bd_category_view, bd_search_view, bd_affinity
 * (also bd-view-tracking.js), and the local-intent clicks phone_call_click,
 * email_click, get_directions_click, store_hours_click
 * (bd-local-intent-tracking.liquid). Calls gtag once
 * ready; queues otherwise. window.bdGa4BrowseQueue holds [name, params]
 * tuples pushed before this file defines the helper, flushed on load.
 *
 * dataLayer.push wrap stays as a backup only. Anything loaded from
 * googletagmanager.com (the gtag.js this file loads included) replaces
 * dataLayer.push, so the wrap must never be the only path — the helper is
 * the contract. (GTM-TWC9KZRX itself was removed 2026-08-31: its only
 * destinations were another BuildDirect brand's G-39G112EFZ7 /
 * AW-994300265 — see ops/gtm-wrong-ads-id-2026-08/.)
 *
 * Never sends purchase, checkout_completed, refund, or other checkout events.
 * Does not invent ecommerce events.
 * Checkout does not load theme.liquid, so this file cannot fire purchase there.
 *
 * Do not reconnect G-9 on Google & YouTube Analytics. Custom pixel
 * 129237082 stays purchase-only.
 */
(function () {
  'use strict';

  var MEASUREMENT_ID = 'G-9HLZQW6SRQ';
  var CONSENT_KEY = 'bd_cookie_consent_v1';
  var ALLOWED = {
    view_item: true,
    view_item_list: true,
    search: true,
    add_to_cart: true,
    begin_checkout: true,
    phone_call_click: true,
    email_click: true,
    get_directions_click: true,
    store_hours_click: true,
    bd_product_view: true,
    bd_category_view: true,
    bd_search_view: true,
    bd_affinity: true
  };
  var BLOCKED = {
    purchase: true,
    checkout_completed: true,
    refund: true,
    add_payment_info: true,
    add_shipping_info: true,
    add_shipping_address_info: true
  };

  if (window.Shopify && (window.Shopify.designMode || window.Shopify.previewMode || window.Shopify.visualPreviewMode)) return;
  if (/[?&](preview_theme_id|preview_key)=/.test(window.location.search)) return;
  if (window.bdGa4BrowseInitialized) return;
  window.bdGa4BrowseInitialized = true;

  var wrapped = false;
  var gtagReady = false;
  var gtagLoading = false;
  var declined = false;
  var queue = [];
  var claimed = Object.create(null);

  function hasDeclined() {
    if (declined) return true;
    try {
      return window.localStorage.getItem(CONSENT_KEY) === 'essential';
    } catch (e) {
      return false;
    }
  }

  function fingerprint(name, params) {
    try {
      return name + '\n' + JSON.stringify(params || {});
    } catch (e) {
      return name;
    }
  }

  function claim(name, params) {
    claimed[fingerprint(name, params)] = Date.now();
  }

  function isClaimed(name, params) {
    var t = claimed[fingerprint(name, params)];
    return t && Date.now() - t < 5000;
  }

  function eventName(item) {
    if (!item || typeof item !== 'object' || Array.isArray(item)) return '';
    if (typeof item.event !== 'string') return '';
    return item.event;
  }

  function copyParams(item) {
    var params = {};
    var src = item.ecommerce && typeof item.ecommerce === 'object' ? item.ecommerce : item;
    var keys = Object.keys(src);
    var i;
    var key;
    for (i = 0; i < keys.length; i++) {
      key = keys[i];
      if (key === 'event' || key === 'ecommerce' || key === 'gtm' || key === 'gtm.uniqueEventId') continue;
      if (src[key] == null) continue;
      params[key] = src[key];
    }
    if (item.search_term && !params.search_term) params.search_term = item.search_term;
    return params;
  }

  function withSendTo(params) {
    var out = {};
    var src = params && typeof params === 'object' && !Array.isArray(params) ? params : {};
    var keys = Object.keys(src);
    var i;
    for (i = 0; i < keys.length; i++) {
      out[keys[i]] = src[keys[i]];
    }
    out.send_to = MEASUREMENT_ID;
    return out;
  }

  function send(name, params) {
    if (BLOCKED[name] || !ALLOWED[name]) return;
    if (hasDeclined()) return;
    if (!gtagReady || typeof window.gtag !== 'function') {
      queue.push({ name: name, params: withSendTo(params) });
      return;
    }
    window.gtag('event', name, withSendTo(params));
  }

  function bdGa4Browse(name, params) {
    if (typeof name !== 'string') return;
    if (BLOCKED[name] || !ALLOWED[name]) return;
    if (hasDeclined()) return;
    params = params && typeof params === 'object' && !Array.isArray(params) ? params : {};
    claim(name, params);
    send(name, params);
  }

  function flushEarlyQueue() {
    var early = window.bdGa4BrowseQueue;
    window.bdGa4BrowseQueue = [];
    if (!early || !early.length) return;
    var i;
    var item;
    var name;
    var params;
    for (i = 0; i < early.length; i++) {
      item = early[i];
      if (Array.isArray(item)) {
        name = item[0];
        params = item[1];
      } else if (item && typeof item === 'object') {
        name = item.name;
        params = item.params;
      } else {
        continue;
      }
      bdGa4Browse(name, params);
    }
  }

  function consider(item) {
    var name = eventName(item);
    var params;
    if (!name || BLOCKED[name] || !ALLOWED[name]) return;
    params = copyParams(item);
    if (isClaimed(name, params)) return;
    send(name, params);
  }

  function wrapDataLayer() {
    if (wrapped) return;
    wrapped = true;
    window.dataLayer = window.dataLayer || [];
    var i;
    for (i = 0; i < window.dataLayer.length; i++) {
      consider(window.dataLayer[i]);
    }
    var originalPush = window.dataLayer.push;
    window.dataLayer.push = function () {
      var result = originalPush.apply(window.dataLayer, arguments);
      var n;
      for (n = 0; n < arguments.length; n++) {
        consider(arguments[n]);
      }
      return result;
    };
  }

  function flushQueue() {
    var pending = queue.splice(0, queue.length);
    var i;
    var name;
    for (i = 0; i < pending.length; i++) {
      name = pending[i].name;
      if (name && ALLOWED[name] && !BLOCKED[name]) {
        if (typeof window.gtag === 'function' && !hasDeclined()) {
          window.gtag('event', name, withSendTo(pending[i].params));
        }
      }
    }
  }

  function onGtagReady() {
    if (gtagReady) return;
    if (hasDeclined()) { gtagLoading = false; return; }
    window.gtag('js', new Date());
    window.gtag('config', MEASUREMENT_ID, { send_page_view: true });
    gtagReady = true;
    flushQueue();
  }

  function loadGtag() {
    if (gtagReady || gtagLoading) return;
    if (hasDeclined()) return;
    gtagLoading = true;
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
    }
    var existing = document.querySelector('script[data-bd-ga4-g9="1"]');
    if (existing) {
      onGtagReady();
      return;
    }
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + MEASUREMENT_ID;
    script.setAttribute('data-bd-ga4-g9', '1');
    script.onload = onGtagReady;
    script.onerror = function () {
      gtagLoading = false;
    };
    document.head.appendChild(script);
  }

  window.bdGa4BrowseQueue = window.bdGa4BrowseQueue || [];
  window.bdGa4Browse = bdGa4Browse;
  flushEarlyQueue();
  wrapDataLayer();

  if (!hasDeclined()) {
    loadGtag();
  } else {
    window.bdGa4BrowseQueue = [];
    queue.length = 0;
  }

  document.addEventListener('bd:cookie-consent', function (event) {
    if (event.detail && event.detail.granted) {
      declined = false;
      loadGtag();
    } else {
      declined = true;
      queue.length = 0;
      window.bdGa4BrowseQueue = [];
    }
  });
})();
